import FloatingVue, { vTooltip } from 'floating-vue'
import 'floating-vue/dist/style.css'

FloatingVue.options.themes.tooltip.placement = 'bottom'

export const tooltip = vTooltip
